// const base_url  = "http://localhost:1507/api/"
const base_url  = "https://appcbackend.onrender.com/api/"



export default base_url